import { get, useFormContext } from 'react-hook-form';
import { memo, useCallback, useRef } from 'react';
import type { FormItemDefinition } from 'types';
import type { RecordsItemProps } from 'components/user/Records/components/RecordsItem.tsx';
import { RecordsItem } from 'components/user/Records/components/RecordsItem.tsx';

export type RecordsItemEditableProps = {
  id: string;
  agendaId?: string;
  definition?: FormItemDefinition;
} & RecordsItemProps;

const RecordsItemEditableBase = (props: RecordsItemEditableProps) => {
  const {
    formState: { errors },
  } = useFormContext();
  const blurBridgeRef = useRef<HTMLInputElement | null>(null);

  const { id, agendaId, recordId } = props;

  const handleConfirm = useCallback(() => {
    const blurBridgeInput = blurBridgeRef.current;
    if (!blurBridgeInput) return;

    let focusOutEvent: Event;
    try {
      focusOutEvent = new FocusEvent('focusout', { bubbles: true });
    } catch {
      focusOutEvent = new Event('focusout', { bubbles: true });
    }

    blurBridgeInput.dispatchEvent(focusOutEvent);
  }, []);

  return (
    <>
      <input
        ref={blurBridgeRef}
        name={id}
        readOnly
        tabIndex={-1}
        aria-hidden
        value=""
        style={{
          position: 'fixed',
          width: 1,
          height: 1,
          opacity: 0,
          pointerEvents: 'none',
        }}
      />
      <RecordsItem
        detail={false}
        parentAgendaId={agendaId}
        recordId={recordId}
        asColumns
        error={get(errors, id)}
        formOptionShouldDirty
        {...props}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export const RecordsItemEditable = memo(RecordsItemEditableBase) as typeof RecordsItemEditableBase;
